import { DateInput, Select, TableSorting } from "components";
import moment from "moment";
import { APPROVAL_OPTIONS } from "utils";
import { TRANSFER_OPTIONS } from "../../utils";
import { FilterType } from "../types";
import { useLocationList } from "../utils";
import { FilterColumn } from "../../components";

type FilterSectionProps = {
  selected: FilterType
  setSelected: (data: FilterType) => void
  setTableActive: React.Dispatch<React.SetStateAction<TableSorting[]>>
  tableActive: TableSorting[]
}

export function FilterSection(props: FilterSectionProps) {
  const { dropdown } = useLocationList()

  return (
    <section className="lg:flex lg:items-end gap-3 mt-2 w-full">
      <DateInput
        label="START DATE"
        wrapperClassName="lg:w-[180px]"
        onChange={(date) => {
          props.setSelected({ ...props.selected, start_date: moment(date).format("YYYY-MM-DD") })
        }}
        selected={props.selected?.start_date ? moment(props.selected?.start_date).toDate() : null}
      />

      <DateInput
        label="END DATE"
        wrapperClassName="lg:w-[180px]"
        onChange={(date) => {
          props.setSelected({ ...props.selected, end_date: moment(date).format("YYYY-MM-DD") })
        }}
        selected={props.selected?.end_date ? moment(props.selected.end_date).toDate() : null}
      />

      <Select
        label="SOURCE LOCATION"
        controlClass="lg:w-[180px]"
        width
        options={dropdown}
        value={dropdown.find((item) => item.value === props.selected.from_location_id)}
        onChange={(e) => { props.setSelected({ ...props.selected, from_location_id: e?.value }) }}
      />

      <Select
        label="DESTINATION LOCATION"
        controlClass="lg:w-[180px]"
        width
        options={dropdown}
        value={dropdown.find((item) => item.value === props.selected.to_location_id)}
        onChange={(e) => { props.setSelected({ ...props.selected, to_location_id: e?.value }) }}
      />

      <Select
        label="STATUS"
        controlClass="lg:w-[180px]"
        width
        options={[{ value: "", label: "ALL" }, ...TRANSFER_OPTIONS]}
        value={TRANSFER_OPTIONS.find((item) => item.value === props.selected.received_status) || { label: 'All', value: "" }}
        onChange={(e) => { props.setSelected({ ...props.selected, received_status: e?.value }) }}
      />

      <Select
        label="APPROVED"
        controlClass="lg:w-[180px]"
        width
        options={[{ value: "", label: "ALL" }, ...APPROVAL_OPTIONS]}
        value={APPROVAL_OPTIONS.find((item) => item.value === props.selected.approval_status) || { label: 'All', value: "" }}
        onChange={(e) => { props.setSelected({ ...props.selected, approval_status: e?.value }) }}
      />

      <FilterColumn 
        dataFilter={props.tableActive} 
        setTableActive={props.setTableActive} 
      />
    </section>
  )
}